export default {
    type: 'success',
    message: '',
    show: false,
    duration: 5000
};
